import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56379846"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col block relative" }
const _hoisted_2 = { class: "input-label" }
const _hoisted_3 = ["value", "disabled", "rows", "placeholder"]
const _hoisted_4 = {
  key: 0,
  class: "error-message",
  "data-ts": "error-label"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TextArea',
  props: {
	value: String,
	label: String,
	placeholder: {
		type: String,
		default: 'Placeholder',
	},
	ariaLabel: String,
	hasError: Boolean,
	errorLabel: String,
	disabled: Boolean,
	resize: {
		type: String,
		default: 'vertical',
	},
	rows: {
		type: String,
		default: '2',
	},
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _renderSlot(_ctx.$slots, "label", {}, () => [
        _createTextVNode(_toDisplayString(__props.label), 1)
      ])
    ]),
    _createElementVNode("textarea", {
      value: __props.value,
      disabled: __props.disabled,
      class: _normalizeClass(['text-area', { 'text-area--error': __props.hasError }]),
      rows: __props.rows,
      placeholder: __props.placeholder,
      style: _normalizeStyle({ resize: __props.resize }),
      "data-test": "text-area",
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('changeValue', ($event.target as HTMLInputElement).value))),
      onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('inputValue', ($event.target as HTMLInputElement).value)))
    }, null, 46, _hoisted_3),
    (__props.hasError)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.errorLabel), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})